import {Routes, Route, generatePath, Navigate} from 'react-router-dom'
import {useScrollTo, lazyLoad} from '@components/lib'
import 'utils/yupExtend'

import routes, {AuthRoute, OnlyNotAuthRoute} from 'routes'
import {MainLayout, NonAuthLayout} from 'layouts'
import {docsOrder} from 'views/Documents/Documents.config'
import NotFound from 'views/NotFound'
import WalletMain from 'views/wallet/WalletMain'
import Unsubscribe from 'views/Unsubscribe'

const Login = lazyLoad(() => import('views/auth/Login'))
const Register = lazyLoad(() => import('views/auth/Register'))
const ChangeEmailRedirectPage = lazyLoad(() => import('views/auth/ChangeEmailRedirectPage'))

// const WalletMain = lazyLoad(() => import('views/wallet/WalletMain'))
const WalletInfo = lazyLoad(() => import('views/wallet/WalletInfo'))
const Notifications = lazyLoad(() => import('views/Notifications'))
const WalletConvert = lazyLoad(() => import('views/wallet/WalletConvert'))
const WalletWithdraw = lazyLoad(() => import('views/wallet/WalletWithdraw'))
const WithdrawalConfirm = lazyLoad(() => import('views/wallet/WithdrawalConfirm'))
const LegacyWallets = lazyLoad(() => import('views/wallet/LegacyWallets'))

const TokenProductions = lazyLoad(() => import('views/TokenProductions'))

const InterConnectWallets = lazyLoad(() => import('views/InterConnectWallet'))

const PackagePurchase = lazyLoad(() => import('views/PackagePurchase'))
// const AnnualPercentage = lazyLoad(() => import('views/AnnualPercentage'))
const GlobalMarketingPlan = lazyLoad(() => import('views/GlobalMarketingPlan'))
const VimePurchase = lazyLoad(() => import('views/VimePurchase'))
const VimeMbasePurchase = lazyLoad(() => import('views/VimeMbasePurchase'))
const CharacterPurchase = lazyLoad(() => import('views/CharacterPurchase'))
// const GlobalCompensatonAPY = lazyLoad(() => import('views/GlobalCompensatonAPY'))
const LegacyProducts = lazyLoad(() => import('views/LegacyProducts'))

// Metaverse Land
const MetaverseLand = lazyLoad(() => import('views/MetaverseLand'))

const Dashboard = lazyLoad(() => import('views/Dashboard'))
const Profile = lazyLoad(() => import('views/Profile'))
const Documents = lazyLoad(() => import('views/Documents'))
// const FAQ = lazyLoad(() => import('views/FAQ'))
const DocumentsView = lazyLoad(() => import('components/DocumentsView'))

const DownLine = lazyLoad(() => import('views/Downline'))

const App = () => {
  useScrollTo()

  return (
    <Routes>
      {/* NonAuth routes start */}
      <Route
        path={`${routes.login.path}/*`}
        element={
          <OnlyNotAuthRoute>
            <NonAuthLayout>
              <Login />
            </NonAuthLayout>
          </OnlyNotAuthRoute>
        }
      />

      <Route
        path={`${routes.register.path}/*`}
        element={
          <NonAuthLayout>
            <Register />
          </NonAuthLayout>
        }
      />

      {/* NonAuth routes end */}

      {/* Documents and support route start */}
      <Route
        {...routes.documents}
        element={
          <Navigate to={generatePath(routes.documents.singleDoc.path, {id: docsOrder[0]})} />
        }
      />
      <Route
        {...routes.documents.singleDoc}
        element={
          <NonAuthLayout>
            <div style={{flex: 1}}>
              <Documents route={routes.documents.singleDoc.path} />
            </div>
          </NonAuthLayout>
        }
      />

      <Route
        path={routes.privacy_statement.path}
        element={
          <NonAuthLayout>
            <DocumentsView />
          </NonAuthLayout>
        }
      />

      {/* <Route
        path={routes.support.path}
        element={
          <NonAuthLayout>
            <div style={{flex: 1}}>
              <FAQ />
            </div>
          </NonAuthLayout>
        }
      /> */}
      {/* Documents and support route end */}

      <Route Component={AuthRoute}>
        <Route path={routes.home.path} Component={Dashboard} />

        {/* Start Wallet routes */}
        <Route path={routes.wallet.path} Component={WalletMain} />
        <Route path={routes.wallet.withdrawConfirm.path} Component={WithdrawalConfirm} />

        <Route path={routes.wallet.info.path} Component={WalletInfo} />
        <Route path={routes.tokenConvert.path} Component={WalletConvert} />
        <Route path={routes.wallet.info.withdraw.path} Component={WalletWithdraw} />
        <Route path={routes.wallet.legacyWallets.path} Component={LegacyWallets} />
        {/* End Wallet routes */}

        <Route path={routes.interconnectWallets.path} Component={InterConnectWallets} />
        <Route path={routes.tokenProductions.path} Component={TokenProductions} />

        {/* Star package purchase */}
        <Route path={`${routes.packagePurchase.path}/*`} Component={PackagePurchase} />

        {/* old apy package */}
        {/* <Route
        path={`${routes.annualPercentageYield.path}/*`}
        Component={
          AnnualPercentage
        }
      />
      */}

        {/* <Route path={`${routes.globalCompensationAPY.path}/*`} Component={GlobalCompensatonAPY} /> */}

        <Route path={`${routes.globalMarketingPlan.path}/*`} Component={GlobalMarketingPlan} />
        <Route path={`${routes.vimePurchase.path}/*`} Component={VimePurchase} />
        <Route path={`${routes.vimeMbasePurchase.path}/*`} Component={VimeMbasePurchase} />
        <Route path={`${routes.characterPurchase.path}/*`} Component={CharacterPurchase} />
        <Route path={`${routes.metaverseLand.path}/*`} Component={MetaverseLand} />
        <Route path={`${routes.legacyProducts.path}/*`} Component={LegacyProducts} />
        {/* End package purchase */}

        {/* Global compensation plan */}
        <Route path={`${routes.gcp.path}/*`} Component={DownLine} />
        <Route path={`${routes.profile.path}/*`} Component={Profile} />

        {/* Change email confirmation */}
        <Route path={routes.changeEmailWithToken.path} Component={ChangeEmailRedirectPage} />

        <Route path={routes.notifications.path} Component={Notifications} />
      </Route>

      {/* unsubscribe */}
      <Route path={routes.unsubscribeWithToken.path} Component={Unsubscribe} />

      <Route
        path={routes.notFound.path}
        element={
          <MainLayout>
            <NotFound />
          </MainLayout>
        }
      />
      <Route path='*' element={<Navigate to={routes.notFound.path} replace />} />
    </Routes>
  )
}

export default App
